let cardStyle = ":host .container .footer { padding: 0.75rem; }";
export const SHADOW_STYLE_CARD = cardStyle;

let ddStyle =
  ".dropdown-item-content { width: 156px !important; white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; }";
export const SHADOW_STYLE_DROPDOWN = ddStyle;

let modalStyle =
  "div.modal { background-color: rgba(0, 0, 0, .46) !important; }";
modalStyle +=
  " div.header, div.content, div.footer { background-color: transparent !important; border-top: none !important; border-bottom: none !important; }";
modalStyle +=
  " button.close { color: white !important; } button.close:hover, button.close:focus { background-color: grey !important; }";
export const SHADOW_STYLE_PREVIEW_MODAL = modalStyle;

let comboboxStyle =
  "div.grid-input { overflow: auto !important; max-height: 300px !important; }";
export const SHADOW_STYLE_COMBOBOX = comboboxStyle;

let chipStyleFix = "span.title { overflow: unset !important; }";
export const CHIP_OVERFLOW_FIX = chipStyleFix;

let calciteInputSearchStyle = "calcite-icon { color: black !important; }";
calciteInputSearchStyle +=
  " .wrapper, input, .element-wrapper, .clear-button { background-color: #f4f4f4 !important; color: black !important; }";
calciteInputSearchStyle +=
  " .wrapper { border: 1px solid #ededed !important; }";
calciteInputSearchStyle += " .element-wrapper { width: 375px; }";
calciteInputSearchStyle +=
  " .wrapper::placeholder, input::placeholder, .element-wrapper::placeholder, .clear-button::placeholder { color: black !important; }";

calciteInputSearchStyle +=
  " @media (prefers-color-scheme: dark) { calcite-icon { color: white !important; } }";
calciteInputSearchStyle +=
  " @media (prefers-color-scheme: dark) { .wrapper, input, .element-wrapper, .clear-button { background-color: black !important; color: white !important; } }";
calciteInputSearchStyle +=
  " @media (prefers-color-scheme: dark) { .wrapper { border: 1px solid #111111 !important; } }";
calciteInputSearchStyle +=
  " @media (prefers-color-scheme: dark) { .wrapper::placeholder, input::placeholder, .element-wrapper::placeholder, .clear-button::placeholder { color: white !important; } }";
export const INPUT_SEARCH_STYLE = calciteInputSearchStyle;

let itemBrowserScrollStyle = ".sheet { z-index: 1100 !important; }";
export const ITEM_BROWSER_SCROLL_STYLE = itemBrowserScrollStyle;

let controlItemStyle = ".label--scale-m { padding-inline: .5rem !important; }";
export const CONTROL_ITEM_STYLE = controlItemStyle;
